import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { FunnelStepId, FunnelStepInterface } from '../types/funnel-step-interface';
import { FunnelPageTemplateId } from '../types/funnel-page-template-interface';
import { FUNNELS_API } from '../../api/funnels-api';
export const useSelectPageTemplate = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: postFetcher,
    isFetching
  } = useFetch(t0);
  let t1;
  if ($[1] !== postFetcher) {
    t1 = (id, pageTemplateId) => postFetcher(`${FUNNELS_API}/steps/${id}/templates/${pageTemplateId}/choose`);
    $[1] = postFetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selectPageTemplate = t1;
  let t2;
  if ($[3] !== isFetching || $[4] !== selectPageTemplate) {
    t2 = {
      selectPageTemplate,
      isFetching
    };
    $[3] = isFetching;
    $[4] = selectPageTemplate;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};